import { Component, OnInit } from '@angular/core';

import { BaseComponent } from 'src/app/core/base-component';
import { TokenManagerService } from 'src/app/core/services/token-manager.service';

@Component({
  selector: 'app-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['footer.component.scss']
})
export class FooterComponent extends BaseComponent implements OnInit {
  IsHidePrice:boolean;
  
  constructor(
    public tokenManagerService: TokenManagerService
  ) {
    super(tokenManagerService);
  }

  ngOnInit(): void {
    this.IsHidePrice = this.tokenManagerService.appConfiguration.IsHidePrice;
  }

}
